import { PartnerId } from '../../common/types';
import { PartnerConfiguration } from './types';

export const PARTNER_CONFIGURATIONS: Record<string, PartnerConfiguration> = {
  default: {
    hideFooter: false,
  },
  [PartnerId.WB_VACANCES_BLEUES]: {
    hideFooter: true,
  },
};

export const getPartnerConfiguration = (partnerId: string) => {
  return PARTNER_CONFIGURATIONS[partnerId] || PARTNER_CONFIGURATIONS['default'];
};
